import { getUsersPreferedSettings } from "../../engine/data/globalState.js";
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS, states } from "../constants.js";
import { WebRTCAdaptor } from "../media-server-external/webrtc_adaptor.js";
import { CONTROLLERS } from "./UnifiedAntMediaController.js";

export class AntMediaControllerCamera {
  constructor(model, pc_config, sdpConstraints, token, roomNameBox, videoMode, myVideoElement, successCallback, errorCallback, controller) {
    this.controller = controller;
    this.successCallback = successCallback;
    this.errorCallback = errorCallback;
    this.model = model;
    this.pc_config = pc_config;
    this.sdpConstraints = sdpConstraints;
    this.token = token;
    this.roomNameBox = roomNameBox;
    this.videoMode = videoMode;
    this.myVideoElement = myVideoElement;
    this.playOnly = false; // or set based on your logic
    this.isCameraOff = false;
    this.insideRoom = false;
    this.publishStreamId = "CAMERA" + this.model.config.userId;
    this.webRTCAdaptor = null;
    this.streamsList = [];
    this.roomTimerId = null;
    this.dominantSpeakerFinderId = null;
    this.isDataChannelOpen = false;
    this.mutedAlertPresent = false;
    this.canvasInfo = {}; // Define the structure based on your needs

    this.state = states.NOT_IN_ROOM;

    this.mediaConstraints = {
      video: true,
      audio: true
    };

    this.sdpConstraints = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true

    };

    this.pc_config = {
      'iceServers': [{
        'urls': 'stun:stun1.l.google.com:19302'
      }]
    };
  }

  muteLocalMic = () => {
    this.isMicMuted = true;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.muteLocalMic();
    this.webRTCAdaptor.enableAudioLevelWhenMuted()
  }

  unmuteLocalMic = () => {
    this.isMicMuted = false;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.unmuteLocalMic();
    this.webRTCAdaptor.disableAudioLevelWhenMuted();
  }

  updateBaglessSocketUsers = () => {
    const data = {
      webcamStreamId: this.publishStreamId,
      userVideoOn: this.model.userWantsCamera,
      userMicOn: this.model.userWantsAudio,
    }
    this.model.socket.userStartedWebRTCStream(data);
  }
  removeFromChair = () => {
    const data = {
      webcamStreamId: null,
    }
    this.model.socket.userStartedWebRTCStream(data);
  }
  leaveRoom = () => {
    // Stop all remote video tracks before leaving
    if (this.streamsList && this.streamsList.length > 0) {
      this.streamsList.forEach((streamId) => {
        const video = document.getElementById("remoteVideo-" + streamId);
        if (video && video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
          video.srcObject = null;
        }
        this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
      });
      this.streamsList = [];
    }

    // Stop local video tracks
    const localVideo = document.getElementById(this.myVideoElement || "myVideo2");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }

    // Leave room and close stream
    this.webRTCAdaptor && this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
    this.closeStream();
  }
  newCameraSelected = () => {
    if (this.state === states.JOINED_ROOM) {
      const cameraId = this.model.view.deviceSettingsMenu.selected.camera.value;
      this.webRTCAdaptor.switchVideoCameraCapture(this.publishStreamId, cameraId)
    }
  }

  checkVideoTrackStatus = (streamList) => {
    if (this.state === states.JOINED_ROOM) {
      streamList.forEach((item) => {
        const video = document.getElementById("remoteVideo-" + item);
        if (video != null && !video.srcObject.active) {
          this.webRTCAdaptor.stop(item);
          // this.controller.removeRemoteVideo(item);
          this.webRTCAdaptor.play(item, null, this.roomNameBox);
        }
        if (video === null) {
          if (this.controller.streamIsMine(item))
            return;
          this.webRTCAdaptor.play(item, null, this.roomNameBox);
        }
      });
    }
  }

  connect() {
    var self = this;
    return new Promise(function (resolve, reject) {
      const webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket",
        mediaConstraints: getUsersPreferedSettings(),
        peerconnection_config: self.pc_config,
        sdp_constraints: self.sdpConstraints,
        // localVideoId: "cameraVideo",
        localVideoId: "myVideo2",
        isPlayMode: false,
        debug: false,
        dataChannelEnabled: false,
        callback: (info, obj) => {
          if (info === "initialized") {
            resolve(self.webRTCAdaptor);
            setTimeout(() => {
              self.joinRoom(self.roomNameBox)
            }, 2000);
            self.updateBaglessSocketUsers();
          }
          if (info === "publish_started") {
            self.updateBaglessSocketUsers();
          }
          if (info === "leavedFromRoom") {
            self.state = states.NOT_IN_ROOM;
          }
          self.handleCallback(info, obj);
        },
        callbackError: function (error, message) {
          self.handleCallbackError(error, message);
        }
      });

      webRTCAdaptor.onerror = function (err) {
        reject(err);
      };

      self.webRTCAdaptor = webRTCAdaptor;
    });
  }

  joinRoom() {
    if (this.model.socket.getUsersObject()[this.model.config.userId]) {
      if (this.model.socket.getUsersObject()[this.model.config.userId].on1on1Call)
        return;
    }
    this.publishStreamId = "CAMERA" + this.model.config.userId;
    this.webRTCAdaptor && this.webRTCAdaptor.joinRoom(this.roomNameBox, this.publishStreamId);
  }

  publish() {
    this.publishStreamId = "CAMERA" + this.model.config.userId;
    this.model.webcamStreamId = this.publishStreamId;
    this.webRTCAdaptor && this.webRTCAdaptor.publish(this.publishStreamId);
  }

  handleCallback(info, obj) {
    if (info == "leavedFromRoom") {
      this.state = states.NOT_IN_ROOM;
      clearInterval(this.roomTimerId);
      clearInterval(this.dominantSpeakerFinderId);

      // Ensure all remote video tracks are stopped
      if (this.streamsList && this.streamsList.length > 0) {
        this.streamsList.forEach((streamId) => {
          const video = document.getElementById("remoteVideo-" + streamId);
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => track.stop());
            video.srcObject = null;
          }
        });
        this.streamsList = [];
      }

      if (this.leaveCallback) {
        this.leaveCallback();
        this.leaveCallback = null;
      }
    }
    if (info == "publish_started") {
      this.state = states.JOINED_ROOM;
    }
    if (info == "joinedTheRoom") {
      this.state = states.JOINED_ROOM;
      if (obj.streams != null) {
        obj.streams.forEach((item) => {
          this.webRTCAdaptor.play(item, this.token, this.roomNameBox)
        });
      }
      this.roomTimerId = setInterval(() => {
        if (this.state === states.JOINED_ROOM) {
          this.webRTCAdaptor && this.webRTCAdaptor.getRoomInfo(this.roomNameBox, this.publishStreamId);
        }
      }, 2000);
      setTimeout(() => {
        this.publish();
      }, 2000);
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.CAMERA_ROOM_JOINED })
    }
    else if (info == "roomInformation") {
      for (let str of obj.streams) {
        if (!this.streamsList.includes(str)) {
          if (!str.includes(this.model.config.userId)) {
            this.webRTCAdaptor.play(str, this.token, this.roomNameBox);
          }
        }
      }
      for (let str of this.streamsList) {
        if (!obj.streams.includes(str)) {
          this.controller.removeRemoteVideo(str);
          this.webRTCAdaptor.stop(str);
        }
      }
      this.streamsList = obj.streams;
      this.checkVideoTrackStatus(this.streamsList)
    }
    this.successCallback && this.successCallback(info, obj, CONTROLLERS.CAMERA);
  }

  handleCallbackError(error, message) {
    // Handle errors from the WebRTCAdaptor
    console.error("Callback Error:", error, message);
    this.errorCallback && this.errorCallback(error, message);
    if (error === "publishTimeoutError") {
      this.publish();
    }
  }
  closeStream() {
    // Stop local video tracks explicitly
    const localVideo = document.getElementById(this.myVideoElement || "myVideo2");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }

    // Close stream via WebRTCAdaptor
    this.webRTCAdaptor && this.webRTCAdaptor.closeStream();
  }

  /**
   * Cleanup all streams and wait for cleanup to complete
   * Returns a Promise that resolves when all streams are closed
   */
  cleanupStreams() {
    return new Promise((resolve) => {
      // If no adaptor exists, resolve immediately
      if (!this.webRTCAdaptor) {
        resolve();
        return;
      }

      // Stop all remote video tracks
      if (this.streamsList && this.streamsList.length > 0) {
        this.streamsList.forEach((streamId) => {
          const video = document.getElementById("remoteVideo-" + streamId);
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => {
              track.stop();
              track.enabled = false;
            });
            video.srcObject = null;
          }
          this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
        });
        this.streamsList = [];
      }

      // Stop local video tracks
      const localVideo = document.getElementById(this.myVideoElement || "myVideo2");
      if (localVideo && localVideo.srcObject) {
        localVideo.srcObject.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        localVideo.srcObject = null;
      }

      // Leave room and close stream
      if (this.webRTCAdaptor) {
        this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
        this.webRTCAdaptor.closeStream();

        // Wait a bit for cleanup to complete, then resolve
        setTimeout(() => {
          this.state = states.NOT_IN_ROOM;
          resolve();
        }, 300);
      } else {
        resolve();
      }
    });
  }
}
